/**
 * Fechas de negocio (contratos, condiciones, facturas) leídas y escritas como fecha local,
 * para que un contrato que parte el día 1 no aparezca el día anterior por la zona horaria.
 */

/**
 * Convierte a fecha local lo que hay guardado en Firestore: Timestamp, Date,
 * "DD-MM-YYYY" (formulario de condiciones) o "YYYY-MM-DD". Devuelve null si no se puede.
 */
export function aFecha(valor: unknown): Date | null {
  if (!valor) return null;
  const conToDate = valor as { toDate?: () => Date };
  if (typeof conToDate.toDate === "function") return conToDate.toDate();
  if (valor instanceof Date) return isNaN(valor.getTime()) ? null : valor;
  if (typeof valor !== "string") return null;
  const texto = valor.trim();
  let match = texto.match(/^(\d{1,2})[-/](\d{1,2})[-/](\d{4})$/);
  if (match) return fechaValida(+match[3], +match[2], +match[1]);
  match = texto.match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
  if (match) return fechaValida(+match[1], +match[2], +match[3]);
  return null;
}

function fechaValida(year: number, month: number, day: number): Date | null {
  const fecha = new Date(year, month - 1, day);
  return fecha.getMonth() === month - 1 && fecha.getDate() === day ? fecha : null;
}

/** "YYYY-MM-DD" según el día local (el formato del v-date-picker), sin pasar por UTC. */
export function aISOLocal(fecha: Date): string {
  const mm = String(fecha.getMonth() + 1).padStart(2, "0");
  const dd = String(fecha.getDate()).padStart(2, "0");
  return `${fecha.getFullYear()}-${mm}-${dd}`;
}
